<template>
  <div class="home-fashion-view">
    <a href="https://act.mogujie.com/zzlx67">
      <img src="@/assets/img/home/recommend_bg.jpg">
    </a>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {

    }
  },
  components: {

  }
}
</script>

<style scoped>
.home-fashion-view img {
  width: 100%;
}
</style>
